import type { ClikArtItem } from '@/api/types/clikart'
import type { ShapePhotoFill } from '@/lib/photos/types/shape-photo-fill'
import { mapClikArtToImageRefs } from './helpers/map-clikart-to-image-refs'

/**
 * Build a `ShapePhotoFill` from a ClikArt item — the ClikArt-side counterpart of
 * `lib/photos/fill-shape-with-photo.ts`'s `buildShapePhotoFill`. Reuses the exact same
 * `ShapePhotoFill` wire shape (`content.image` on the wire) with `pezId` populated instead of
 * `imageId` — see `map-clikart-to-image-refs.ts`.
 */
export function buildShapeClikArtFill(
  item: ClikArtItem,
  naturalSize?: { width: number; height: number }
): ShapePhotoFill {
  const refs = mapClikArtToImageRefs(item)

  return {
    imageId: refs.imageId,
    imageType: refs.imageType,
    pezId: refs.pezId,
    previewUrl: item.scrUrl,
    displayName: item.displayName,
    offsetX: 0,
    offsetY: 0,
    scale: 1,
    ...(naturalSize ? { naturalWidth: naturalSize.width, naturalHeight: naturalSize.height } : {}),
  }
}
